import React from 'react'
import fb from '../../assets/images/fb.png'
import lin from '../../assets/images/in.png'
import yt from '../../assets/images/yt.png'
import QR_code from '../../assets/images/QR_code.png'
import gg from '../../assets/images/gg.png'
import app_store from '../../assets/images/app-store.png'
import bct from '../../assets/images/bo-cong-thuong.png'

export default function Section2() {
  return (
    <div className="container mx-auto max-md:flex-wrap w-full p-[30px] flex justify-between">
        <div className="max-md:w-full md:w-[30%] pr-[30px]">
            <p className='text-[16px]'><b>THÔNG TIN LIÊN HỆ</b></p>
            <p className='text-[13px] py-[5px] text-[#777A80]'>Tên công ty</p>
            <p className='text-[14px] py-[5px]'><b>CÔNG TY TNHH MYU</b></p>
            <p className='text-[13px] py-[5px] text-[#777A80]'>Địa chỉ</p>
            <p className='text-[14px] py-[5px]'><b>642 Âu Cơ, Phường 10, Quận Tân Bình, Thành phố Hồ Chí Minh, Việt Nam</b></p>
            <p className='text-[13px] py-[5px] text-[#777A80]'>GCN ĐKDN số</p>
            <p className='text-[14px] py-[5px]'><b>0317747312</b></p>
            <p className='text-[13px] py-[5px] text-[#777A80]'>Cấp ngày</p>
            <p className='text-[14px] py-[5px]'><b>22/03/2023</b></p>
            <p className='text-[13px] py-[5px] text-[#777A80]'>Nơi cấp</p>
            <p className='text-[14px] py-[5px]'><b>Phòng đăng ký kinh doanh - Sở Kế hoạch & Đầu tư TP HCM</b></p>
        </div>

        <div className="max-md:w-full max-md:mt-[20px] md:w-[20%]">
            <p className='text-[16px] py-[5px]'><b>CHĂM SÓC KHÁCH HÀNG</b></p>
            <p className='text-[13px] py-[5px] text-[#777A80]'>Thời gian hỗ trợ</p>
            <p className='text-[14px] py-[5px]'><b>8H - 22H Hàng ngày</b></p>
            <p className='text-[13px] py-[5px] text-[#777A80]'>Hotline KHTT</p>
            <p className='text-[14px] py-[5px]'><b>096 446 0333</b></p>
        </div>

        <div className="max-md:w-full max-md:mt-[20px] md:w-[25%]">
            <p className='text-[16px]'><b>CHÍNH SÁCH CHƯƠNG TRÌNH</b></p>
            <a href='https://myu.vn/giao-duc/gioi-thieu'><p className='text-[13px] py-[10px] text-[#777A80]'>Giới thiệu về myU</p></a>
            <a href=' '><p className='text-[13px] py-[10px] text-[#777A80]'>Quy chế hoạt động App myU</p></a>
            <a href=' '><p className='text-[13px] py-[10px] text-[#777A80]'>Quy chế hoạt động Website myU</p></a>
            <a href=' '><p className='text-[13px] py-[10px] text-[#777A80]'>Điều khoản và Điều kiện chương trình KHTT</p></a>
            <a href=' '><p className='text-[13px] py-[10px] text-[#777A80]'>Chính sách bảo vệ và xử lý dữ liệu</p></a>
            <a href=' '><p className='text-[13px] py-[10px] text-[#777A80]'>Chính sách xóa tài khoản trên ứng dụng myU</p></a>
            <a href=' '><p className='text-[13px] py-[10px] text-[#777A80]'>Thỏa thuận sử dụng dịch vụ mạng xã hội</p></a>
        </div>

        <div className="max-md:w-full max-md:mt-[20px] md:w-[25%]">
            <p className='text-[16px]'><b>KẾT NỐI VỚI CHÚNG TÔI</b></p>
            <div className='flex mt-[10px]'>
                <a href='https://www.facebook.com/myu.vn'><img src={fb} alt='icon' className='mx-[5px]' /></a>
                <a href=' '><img src={lin} alt='icon' className='mx-[5px]' /></a>
                <a href=' '><img src={yt} alt='icon' className='mx-[5px]' /></a>
            </div>

            <p className='text-[16px] my-[20px]'><b>TẢI APP TRÊN ĐIỆN THOẠI</b></p>
            <div className='flex items-center'>
                <img src={QR_code} alt='icon' className='mx-[5px] w-[100px] h-[100px]' />
                <div>
                    <a href='https://play.google.com/store/apps/details?id=vn.hhholding.myuapp&pli=1' target='_blank'><img src={gg} alt='icon' className='mx-[5px]' /></a>
                    <a href='https://apps.apple.com/us/app/myu/id6449179762' target='_blank'><img src={app_store} alt='icon' className='mx-[5px] mt-[5px]' /></a>
                </div>
            </div>

            <p className='text-[16px] my-[20px]'><b>ĐƯỢC CHỨNG NHẬN BỞI</b></p>
            <div className='flex items-center'>
                <a href='http://online.gov.vn/Home/WebDetails/103822?AspxAutoDetectCookieSupport=1' target='_blank'><img src={bct} alt='icon' className='mx-[5px]' /></a>
            </div>
        </div>
    </div>
  )
}
